(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.modal-switch');
      if (!btn) return;

      e.preventDefault();

      var targetId = btn.getAttribute('data-modal-id');
      if (!targetId) return;

      var currentModal = btn.closest('.js-modal');
      if (!currentModal) return;

      var closeBtn = currentModal.querySelector('.js-modal-close');
      if (!closeBtn) return;

      var opened = false;

      var onClose = function () {
        if (currentModal.getAttribute('aria-hidden') === 'true') {
          currentModal.removeEventListener('transitionend', onClose);
          currentModal.removeEventListener('animationend', onClose);

          if (!opened) {
            opened = true;
            document.querySelector('[data-modal-id="' + targetId + '"]')?.click();
          }
        }
      };

      currentModal.addEventListener('transitionend', onClose);
      currentModal.addEventListener('animationend', onClose);

      closeBtn.click();
    });
  }
})();